import { render, staticRenderFns } from "./FundAllocator.vue?vue&type=template&id=29b7a41c"
import script from "./FundAllocator.vue?vue&type=script&lang=js"
export * from "./FundAllocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports